/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Partnerfunding1Inputs */

const de__field_partnerfunding1 = /** @type {(inputs: _Field_Partnerfunding1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förderpartner:in`)
};

/**

* @param {_Field_Partnerfunding1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_partnerfunding1 = /** @type {((inputs?: _Field_Partnerfunding1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Partnerfunding1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_partnerfunding1(inputs)
});
export { _field_partnerfunding1 as "_field_partnerFunding" }